import { render, staticRenderFns } from "./RequestedPartComponent.vue?vue&type=template&id=55cd9b45&"
import script from "./RequestedPartComponent.vue?vue&type=script&lang=js&"
export * from "./RequestedPartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports